import { RefObject, useEffect } from 'react';

import { isDefined } from '../../utils/variables';
import { InputKeys } from '../../viewer/input-handler';

/**
 * Hooks up a keyup event to trigger a button click.
 * If no ref is passed the hook will do nothing.
 */
export const useButtonHotkey = (
  element: RefObject<HTMLButtonElement> | undefined,
  key: InputKeys,
  options?: { bubble: boolean },
) => {
  useEffect(() => {
    if (!isDefined(element)) {
      return;
    }

    const handleKeyPress = (event: KeyboardEvent) => {
      if (isDefined(element.current) && event.key === key) {
        event.preventDefault();
        event.stopPropagation();
        element.current.click();
      }
    };

    const eventOptions = options?.bubble ?? false;
    window.addEventListener('keydown', handleKeyPress, eventOptions);

    return () => {
      window.removeEventListener('keydown', handleKeyPress, eventOptions);
    };
  }, [element, key, options]);
};
